import App from "App";
import { Navigate } from "react-router-dom";
import ErrorPage from "./ErrorPage";
import Dashboard from "@features/dashboard";
import { getLoggedInUser } from "@utils/helpers";
import RegulatorFilling from "@features/regulatorFilling";
import ImportExport from "@features/importExport";
import OtherInsights from "@features/otherInsights";
import Preview from "@common/Page/component/Preview";
import ProductInsights from "@features/productInsights";
import Settings from "@features/settings";
import Users from "@features/settings/pages/Users";
import { ADMIN, USER } from "@utils/roleRights";
import AdvanceSearch from "@features/advanceSearch";
import Manage from "@features/manage";
import { allowedEmails } from "@common/layout/navlinks";

const ProtectedRoute = ({ element, allowedRoles, allowedEmails }) => {
  const user = getLoggedInUser();
  const isAuthenticated = user && user.loggedIn;
  
  const role = user && user?.user?.isAdmin ? "ADMIN" : "USER";
  const email = user?.user?.email;
  if (
    (allowedRoles && !allowedRoles.includes(role)) ||
    (allowedEmails.length && !allowedEmails.includes(email))
  ) {
    return <Navigate to="/" state={{ replace: true }} />;
  }

  return isAuthenticated ? element : <Navigate to="/login" />;
};

const routes = [
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
    allowedRoles: [ADMIN, USER],
    allowedEmails: [],
    children: [
      {
        index: true,
        element: <Dashboard />,
        allowedRoles: [ADMIN, USER],
        allowedEmails: [],
      },
      {
        path: "/dashboard",
        element: <Dashboard />,
        allowedRoles: [ADMIN, USER],
        allowedEmails: [],
      },
      {
        path: "/advance_search",
        element: <AdvanceSearch />,
        allowedRoles: [ADMIN, USER],
        allowedEmails: [],
      },
      {
        path: "/regulator_filling",
        element: <RegulatorFilling />,
        allowedRoles: [ADMIN, USER],
        allowedEmails: [],
      },
      {
        path: "/import_export",
        element: <ImportExport />,
        allowedRoles: [ADMIN, USER],
        allowedEmails: [],
      },
      {
        path: "/other_insights",
        element: <OtherInsights />,
        allowedRoles: [ADMIN, USER],
        allowedEmails: [],
      },
      {
        path: "/manage",
        element: <Manage />,
        allowedRoles: [ADMIN, USER],
        allowedEmails: allowedEmails,
      },
      {
        path: "/preview",
        element: <Preview />,
        allowedRoles: [ADMIN, USER],
        allowedEmails: [],
      },
      {
        path: "/product_insights",
        element: <ProductInsights />,
        allowedRoles: [ADMIN, USER],
        allowedEmails: [],
      },
      {
        path: "/settings",
        element: <Settings />,
        allowedRoles: [ADMIN],
        allowedEmails: [],
      },
      {
        path: "/settings/manage-users",
        element: <Users />,
        allowedRoles: [ADMIN],
        allowedEmails: [],
      },
    ],
  },
];

export const protectedRoutes = [
  ...routes.map((route) => {
    return {
      path: route.path,
      element: (
        <ProtectedRoute
          element={route.element}
          allowedRoles={route.allowedRoles}
          allowedEmails={route.allowedEmails}
        />
      ),
      errorElement: route.errorElement,
      children:
        route.children && route.children?.length
          ? route.children.map((route) => {
              return {
                path: route.path,
                element: (
                  <ProtectedRoute
                    element={route.element}
                    allowedRoles={route.allowedRoles}
                    allowedEmails={route.allowedEmails}
                  />
                ),
                index: route.index,
              };
            })
          : [],
    };
  }),
];
